export const PSW_C = 0x80;
export const PSW_Z = 0x40;
export const PSW_S = 0x20;
export const PSW_OV = 0x10;
export const PSW_MIE = 0x08;
export const PSW_HC = 0x04;
export const PSW_ELEVEL = 0x03;

export const H_IE = 0x0001;
export const H_ST = 0x0002;
export const H_DW = 0x0004;
export const H_DS = 0x0008;
export const H_IA = 0x0010;
export const H_TI = 0x0020;
export const H_WB = 0x0040;
